exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#advisor-nav{height:74px;padding:12px 18px;box-shadow:0px 1px 4px 0px rgba(0,42,84,.25);background-color:#fff}#partner-logo{max-height:35px}#advisor-nav #advisor-agent-nav{float:right;padding-top:10px;display:inline-flex;margin-right:25px;cursor:pointer}#chat-icon{padding-right:15px;vertical-align:middle}#isc-profile{font-size:17px;overflow-wrap:break-word;width:140px;line-height:15px}#isc-name{font-size:12px}#get-support{font-size:14px;text-decoration:none;color:#304393;cursor:pointer;font-weight:normal}#get-support:hover{text-decoration:none}.z-index-button{z-index:1000 !important}.image-style{height:45px;width:48px;text-align:center;font-weight:500;font-size:23px;overflow:hidden}.padding-class{padding-top:.45rem;padding-bottom:.45rem}.padding-y-small{padding-top:.35rem}.stylecss .MuiPaper-rounded{border-radius:10px !important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Layout/Nav.scss
// module id = 1102
// module chunks = 74